import React from "react";
import classNames from "classnames";
import "./index.scss";

import LinkControl from "../LinkControl";
import { getTranslateTitle } from '../../../utils/objects-util.js';

const SectionItemLinkControl = ({ column, item, onLayout }) => {
    return (
        <div className={classNames("sectionItemLinkControl")}>
            <LinkControl 
                isDisabled={column.isDisabled && column.isDisabled(item)}
                column={{ title: getTranslateTitle(column.title), isLayout: column.isLayout }}
                value={column.url(item)} 
                onClick={()=> onLayout(column.url(item), item)} 
            />
        </div>
    );
}

export default SectionItemLinkControl;
